<template>
  <header class="modern-header">
    <nav class="nav-container">
      <router-link to="/" class="logo-link">
        <h1 class="logo-title">WordCloudStudio</h1>
        <span class="logo-subtitle">WordArt Tool</span>
      </router-link>
      
      <div class="nav-links">
        <a href="https://apps.apple.com/us/app/wordcloudstudio-wordart-tool/id6504160406" 
           target="_blank" 
           class="nav-link btn-glass">
          <span class="link-icon">📱</span>
          <span class="link-text">App Store</span>
        </a>
        <a href="https://studio.wordcloudmaster.com" 
           target="_blank" 
           class="nav-link btn-primary">
          <span class="link-icon">✨</span>
          <span class="link-text">Online Editor</span>
        </a>
      </div>
    </nav>
  </header>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Header',
};
</script>

<style scoped>
.modern-header {
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
  padding: var(--spacing-lg) 0;
  background: rgba(15, 15, 35, 0.8);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  animation: fadeInDown 0.6s ease-out;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.nav-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 var(--spacing-xl);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-lg);
}

.logo-link {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
  text-decoration: none;
  transition: all var(--transition-base);
}

.logo-link:hover {
  transform: translateY(-2px);
}

.logo-title {
  font-size: var(--font-size-2xl);
  font-weight: 800;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: -0.5px;
  animation: gradient-shift 3s ease infinite;
}

.logo-subtitle {
  font-size: var(--font-size-sm);
  color: var(--text-muted);
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.nav-links {
  display: flex;
  gap: var(--spacing-md);
  align-items: center;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-lg);
  border-radius: var(--radius-full);
  font-size: var(--font-size-sm);
  font-weight: 600;
  text-decoration: none;
  transition: all var(--transition-base);
  white-space: nowrap;
}

.nav-link .link-icon {
  font-size: var(--font-size-lg);
  transition: transform var(--transition-base);
}

.nav-link:hover .link-icon {
  transform: scale(1.2) rotate(5deg);
}

.nav-link.btn-glass {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: var(--text-primary);
}

.nav-link.btn-glass:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.nav-link.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-size: 200% auto;
  color: white;
  border: none;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.nav-link.btn-primary:hover {
  background-position: right center;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);
}

/* Responsive Design */
@media (max-width: 768px) {
  .nav-container {
    padding: 0 var(--spacing-md);
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .logo-title {
    font-size: var(--font-size-xl);
    text-align: center;
  }

  .logo-subtitle {
    font-size: var(--font-size-xs);
    text-align: center;
  }

  .nav-links {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }

  .nav-link {
    flex: 1;
    min-width: 140px;
    justify-content: center;
    padding: var(--spacing-sm) var(--spacing-md);
  }

  .link-text {
    font-size: var(--font-size-xs);
  }
}

@media (max-width: 480px) {
  .modern-header {
    padding: var(--spacing-md) 0;
  }

  .nav-links {
    flex-direction: column;
    gap: var(--spacing-sm);
  }

  .nav-link {
    width: 100%;
  }
}
</style>